// extracted by mini-css-extract-plugin
module.exports = {"accordionButton":"styles_accordionButton___iJA3","accordionPanel":"styles_accordionPanel___Lnw9"};